import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, message } from "antd";
import { useEffect } from "react";
import { handleDeleteAutoRequest } from "../../../api/autorequests";
import { useNavigate } from "react-router";

export default function DeleteRequest({
  isVisible,
  setVisible,
  selected,
  redirect = false,
}: any) {
  const { _id } = selected;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationFn: handleDeleteAutoRequest,
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      queryClient.invalidateQueries({ queryKey: ["autorequests"] });
      queryClient.invalidateQueries({ queryKey: ["unitRequests"] });
      if (redirect) {
        navigate("/autoline/requests");
      }
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    await mutate({ _id });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected, form]);

  return (
    <Modal
      open={isVisible}
      title="Delete Request"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="deleteAutorequest"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form
        id="deleteAutorequest"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-automark-dark font-bold mx-1">Delete</span>
            Request
          </div>
          <div className="font-bold text-lg capitalize">
            Role: {selected?.designation} for {selected?.name}
          </div>
          <span className="text-gray-700">
            {selected?.companies?.map((company: any) => company).join(", ") ||
              "-"}
          </span>
        </div>
      </Form>
    </Modal>
  );
}
